import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { ROUTES } from "./Routes/routes";
import PrivateRoute from "./Routes/privateRoute";

class AppRoutes extends Component {
  renderRoutes() {
    return ROUTES.map((route) => {
      const routeKey = `${route.key} ${route.title}`;
      if (route.isPrivate)
        return (
          <PrivateRoute exact key={routeKey} path={route.link} component={route.component} />
        );
      return (
        <Route
          exact
          key={routeKey}
          path={route.link}
          component={route.component}
        />
      );
    });
  }

  render() {
    return <Switch>{this.renderRoutes()}</Switch>;
  }
}

export default AppRoutes;
